import faqDropdown from './js/old/faqDropdown';

faqDropdown();
